import { type HttpClient, type UserAgent } from "silver";
import { type MyonApiResponse, isMyonApiSuccess } from "shared/Api/MyonApiResponse";
import { AppIntentType, getMobileIntentType } from "core/AppIntents";

type AuthKeyType = "pin" | "auth";

interface AuthKeyResponse {
	authkey: string;
	expires: string;
}

export class AppPinService {

	constructor(
		private mobileApiDomain: string,
		private userAgent: UserAgent,
		private httpClient: HttpClient
	) { }

	private async getAuthKey(type: AuthKeyType): Promise<string> {
		const response: MyonApiResponse<AuthKeyResponse> = await this.httpClient.post(`/api/mobile/authKeys.json?type=${type}`);
		if (!isMyonApiSuccess(response)) {
			throw new Error("authKeys call failed");
		}
		return response.result.authkey;
	}

	public getPin(): Promise<string> {
		return this.getAuthKey("pin");
	}

	public async getAppLoginLink(username: string, buildingId: number): Promise<string|null> {
		const intent = getMobileIntentType(this.userAgent);
		if (intent !== AppIntentType.Android && intent !== AppIntentType.iOS) {
			return null;
		}

		const authToken = await this.getAuthKey("auth");
		const encodedUsername = encodeURIComponent(username);

		switch (intent) {
			case AppIntentType.iOS:
				return `myon://auth?domain=${this.mobileApiDomain}&token=${authToken}&username=${encodedUsername}&buildingId=${buildingId}`;
			case AppIntentType.Android:
				return `intent://myon/sso_login?domain=${this.mobileApiDomain}&token=${authToken}&username=${encodedUsername}&buildingId=${buildingId}#data#Intent;scheme=link;package=com.capstonedigital;S.market_referrer=my%20referrer%20data;end`;
		}

		// Add no final return here - this is safe *because* it has no final return, requiring the entire union represented in the switch
	}
}
